import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';

//css
import './petfriendly.css';

export default class PetFriendly extends React.Component {

    render() {
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Pet Friendly</title>
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Pet Friendly</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<Grid container spacing={16}>
							<Grid item md={12} xs={12} >
								<div className="pet_rules" >
									<Typography variant="h6" >Aqui, seu pet se sente em casa.</Typography>
									<Typography variant="body1">Confira as regras para trazer seu amiguinho para dar uma voltinha no Shopping Norte Sul.</Typography>
									<Typography variant="h6" >Circulação:</Typography>
									<Typography variant="body1">Cães pequenos e médios só podem circular pelo mall de coleira ou no colo. Os de grande porte (ou acima de 20kg) devem estar de coleira e focinheira. Cães menores bravos também devem usar farinheiras para circular pelo shopping.</Typography>
									<Typography variant="h6" >Escadas rolantes:</Typography>
									<Typography variant="body1">Cães pequenos podem acessar a escada rolante somente no colo. Cães médios e grandes devem acessar o 2º piso pelo elevador social.</Typography>
									<Typography variant="h6" >Acesso às lojas:</Typography>
									<Typography variant="body1">O acesso ao interior das lojas com animais é permitido somente naquelas identificadas com um adesivo em sua vitrine.</Typography>
									<Typography variant="h6" className="no_margin">FIQUE TRANQUILO. AQUI VOCÊ ENCONTRA:</Typography>
									<Typography variant="h6" className="no_margin">BEBEDOURO PARA PETS / SAQUINHOS CATA CACA</Typography>
									<Typography variant="h6" >FIQUE ATENTO!</Typography>
									<Typography variant="body1">Apenas cães-guias podem acessar o cinema e as áreas de alimentação.</Typography>
								</div>
							</Grid>
						</Grid>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/petfriendly/index.js